import { OpaccFilter } from './classes/opacc.class.filter.js';
import { OpaccFilterCriterias } from './classes/opacc.class.filter-criterias.js';
import { OpaccTablesortFilter } from './classes/opacc.class.filter-tablesort.js';

export const opaccFilterCriterias = new OpaccFilterCriterias();
export const opaccFilterPlugin = new OpaccFilter(opaccFilterCriterias);
export const opaccTablesortFilter = new OpaccTablesortFilter();